import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/verify")({ component: Verify });

/**
 * Landing page for the email-verification link. Better Auth verifies the
 * token server-side on /api/auth/verify-email before redirecting here, so
 * this page only has to say so.
 */
function Verify() {
  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl text-gray-900">Email verified</h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Thanks, your email address is confirmed.{" "}
          <Link to="/sign-in" className="font-medium text-primary-600 hover:text-primary-500">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
